export const environment = {
  basePath: '/api',
  keycloak: {
    url: 'https://auth-live.recette.aqualter.com',
    realm: 'portal',
    clientId: 'portal-dev',
    logoutURI: 'https://live.recette.aqualter.com',
  },
};
